export default __webpack_public_path__ + "static/media/714hz-overcome-emotional-problems.c369f895.mp3";